<template>
  <div>
    <div class="page-index pc">
      <home-section1></home-section1>
      <home-section2></home-section2>
      <home-section3></home-section3>
      <home-section4></home-section4>
      <home-section5></home-section5>
      <home-section6></home-section6>
    </div>
    <div class="page-index mobile">
    <home-section1m></home-section1m>
    <home-section2m></home-section2m>
    <home-section3m></home-section3m>
    <home-section4m></home-section4m>
    <home-section5m></home-section5m>
    <home-section6m></home-section6m>
    </div>
  </div>
</template>

<script>
  import homeSection1 from './components/pc/section1'
  import homeSection2 from './components/pc/section2'
  import homeSection3 from './components/pc/section3'
  import homeSection4 from './components/pc/section4'
  import homeSection5 from './components/pc/section5'
  import homeSection6 from './components/pc/section6'

  import homeSection1m from './components/mobile/section1m'
  import homeSection2m from './components/mobile/section2m'
  import homeSection3m from './components/mobile/section3m'
  import homeSection4m from './components/mobile/section4m'
  import homeSection5m from './components/mobile/section5m'
  import homeSection6m from './components/mobile/section6m'

  export default {
    name: 'pageHome',
    components: {homeSection1,homeSection2,homeSection3,homeSection4,homeSection5,homeSection6,homeSection1m,homeSection2m,homeSection3m,homeSection4m,homeSection5m,homeSection6m},
    data () {
      return {
        scroll:null


      }
    },
    created () {
      this.getList()
    },
    mounted () {

    },
    methods: {
      getList() {

      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/assets/css/public.styl"
  .realize-more
    user-select none;cursor pointer
  h2,h3,h4,h5,h6,p
    margin: 0 !important
</style>
